import { DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS } from 'common/components';
import { DESIGN_STUDIO_LANDING_NAME } from 'landings/design-studio/design-studio-constants';
import { ImageStructure } from './design-studio-gallery-types';

const createGalleryImage = (imageName: string, alt: string) => {
  const imageNameJpg = imageName.replace('gif', 'jpg');

  return {
    src: `${DESIGN_STUDIO_LANDING_NAME}/gallery-popup/${imageNameJpg}`,
    srcSmall: `${DESIGN_STUDIO_LANDING_NAME}/gallery/${imageName}`,
    alt,
    name: alt,
  };
};

export const createGalleryList = (imageList: ImageStructure[]) =>
  imageList.map(({ imageName, alt }, index) => {
    const baseInfo = createGalleryImage(imageName, alt);

    if ((index + 1) % 10 === 4 || (index + 1) % 10 === 8) {
      return {
        ...baseInfo,
        transformations: DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
      };
    }

    return baseInfo;
  });
